import { module as modujs } from "modujs";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

gsap.registerPlugin(ScrollTrigger, SplitText);

export default class extends modujs {
	constructor(m) {
		super(m);

		this.gsapInstances = [];
	}

	init() {
		this.$items = this.$("item");
		this.stagger = this.getData("stagger");

		if (this.$items.length == 0) {
			this.$items = [this.el];
		}

		document.fonts.ready.then(() => {
			this.buildAnimation();
		});
	}

	buildAnimation() {
		this.tl = gsap.timeline({
			scrollTrigger: {
				trigger: this.el,
				start: "top 80%",
			},
			delay: 0.6,
		});

		this.$items.forEach(($element, index) => {
			let effect = $element.getAttribute("data-animation-effect");
			let delay = $element.getAttribute("data-animation-delay") ?? this.stagger;
			delay = delay ? delay : 0;
			delay = index == 0 ? 0 : delay;

			if (gsap.effects[effect]) {
				this.tl[effect]($element, {}, `<${delay}`);
			}
		});

		this.gsapInstances.push(this.tl);
	}

	destroy() {
		this.gsapInstances.forEach((instance) => {
			if (instance) {
				instance.timeScale(2).reverse();
			}
		});
		window.swup.hooks.once("content:replace", (visit) => {
			this.gsapInstances.forEach((instance) => {
				if (instance) {
					if (instance.scrollTrigger) {
						instance.scrollTrigger.kill();
					}
					instance.kill();
				}
			});
			this.gsapInstances = [];
		});
	}
}
